import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allSuppliers } from 'app/mocks/data/catalogue/suppliers'

import { api } from 'app/utils/constants'

export const getSupplier = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.suppliers.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const supplierFound = allSuppliers.find(
            (supplier) => supplier.id.toString() === id,
        )

        // Not found
        if (!supplierFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json(supplierFound)
    },
)
